export type DescriptorType = 'Date' | 'DateTime' | 'String' | 'StringLong' | 'Number' | 'Bool' | 'Currency';

export const DescriptorType = {
  Date: 'Date' as DescriptorType,
  DateTime: 'DateTime' as DescriptorType,
  String: 'String' as DescriptorType,
  StringLong: 'StringLong' as DescriptorType,
  Number: 'Number' as DescriptorType,
  Bool: 'Bool' as DescriptorType,
  Currency: 'Currency' as DescriptorType
};